export default {
    common: {
        title: "Redigera bild",
        cancel: "Avboka",
        save: "Spara",
        crop: "Gröda",
        adjustments: "Justeringar",
        filters: "Filter",
        frames: "Ramar",
        overlays: "Överlagringar",
        text: "Text",
        stickers: "klistermärken",
        brush: "Borste",
        ai: "Skapa bild med AI",
        reset: "Återställa",
        comingSoon: 'Inom kort...',
    },
};
